const ru = {
  "lines": [
    "Псс! Ты меня уже нашёл?",
    "Бу! Просто заглянул проведать.",
    "Никому не говори, что я здесь…",
    "Кажется, где-то пахнет вафлями…",
    "Ты не видел мой водопад?",
    "Тсс… я прячусь от охотников на троллей!",
    "Листай дальше — я за тобой слежу!",
    "Уже 1 февраля?"
  ],
  "giant": [
    "ПРИВЕТ ТАМ, ВНИЗУ!",
    "Кто это листает на моём мосту?",
    "Я не большой. Это ты маленький."
  ],
  "golden": "Ты заметил золотого тролля! Меня видят лишь немногие счастливчики.",
  "goldenTag": "Легендарный"
};

export default ru;
